<div >
    <div class="margin-bottom-10">
        <input type="file" name="file" id="file"  (change)="FileChosen($event.target.files)">
        <label class="ui button centered" for="file">Choisir une image</label>
    </div>

    <span *ngIf="picture" class="centered">
        <img alt="picture-upload" [src]="picture" class="centered">
    </span>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/picture-upload/picture-upload.html